import { sendAnalyticsInfo } from 'features/analytics/helpers';
import type { CommentType } from 'features/call/call-comments/enums';
import { VrsCallCommentsLogMessages } from 'features/call/vrs-call-comments/enums';

export const closeCallAnalytics = (methodName: string) => {
  return sendAnalyticsInfo({
    Method: methodName,
    Message: VrsCallCommentsLogMessages.CALL_COMPLETE_INITIATE,
  });
};

export const callCommentsFormSubmitAnalytics = (
  methodName: string,
  commentTypes: CommentType[]
) => {
  return sendAnalyticsInfo({
    Method: methodName,
    Message: VrsCallCommentsLogMessages.VRS_REPORT_SENT_SUCCESS,
    CommentTypes: commentTypes,
  });
};
